module.exports = __webpack_public_path__ + "sport.svg?05d3ac4b5b0a9cdf873468a74ae7210b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sport.svg
// module id = 121
// module chunks = 0